import {
  Request, XHRConnection, BrowserXhr,
  ResponseOptions, XHRBackend, XSRFStrategy
} from "@angular/http";
import {Injectable, Component, ViewChild, Renderer, ElementRef} from "@angular/core";
import {Observable, Subscriber} from "rxjs/Rx";
/*import "rxjs/add/operator/do";
 import "rxjs/add/operator/finally";*/

@Component({

  selector: 'loading-bar',
  template: `
    <div id="loading-bar-spinner" #loadingBarSpinner><div class="spinner-icon"></div></div>
    <div id="loading-bar" #loadingBarContainer><div class="bar" #loadingBar><div class="peg"></div></div></div>
    `
})
export class LoadingBar {
  public static _loadingBarComponentInstance: LoadingBar;

  @ViewChild('loadingBarSpinner') _spinner: any;
  @ViewChild('loadingBarContainer') _loadingBarContainer: any;
  @ViewChild('loadingBar') _loadingBar: any;

  private _autoIncrement: boolean = true;
  private _includeSpinner: boolean = true;
  private _includeBar: boolean = true;
  private _latencyThreshold: number = 10;
  private _startSize: number = 0.02;

  private _started: boolean = false;
  private _status: number = 0;

  private _incTimeout: any;
  private _completeTimeout: any;

  private _startTimeout: any;

  constructor(private _renderer: Renderer, private elRef: ElementRef) {
    LoadingBar._loadingBarComponentInstance = this;
    this.attachToRoot();
  }

  private attachToRoot() {
    let rootEl = document.getElementsByTagName('ion-app')[0];
    rootEl.appendChild(this.elRef.nativeElement);
  }

  public ngAfterViewInit() {
    this.hide(this._loadingBarContainer);
    this.hide(this._spinner);
  }

  /**
   * Inserts the loading bar element into the dom, and sets it to 2%
   */
  public start(): void {
    this._startTimeout = setTimeout(() => {

      clearTimeout(this._completeTimeout);

      // do not continually broadcast the started event:
      if (this._started) {
        return;
      }

      this._started = true;
      this._status = 0;

      if (this._includeBar) {
        this.show(this._loadingBarContainer);
      }

      if (this._includeSpinner) {
        this.show(this._spinner);
      }

      this.set(this._startSize);
    }, this._latencyThreshold);
  }

  /**
   * Set the loading bar's width to a certain percent.
   *
   * @param n any value between 0 and 1
   */
  public set(n): void {
    if (!this._started) {
      return;
    }
    var pct = (n * 100) + '%';
    this.setElementStyle(this._loadingBar, "width", pct);
    this._status = n;

    // increment loadingbar to give the illusion that there is always
    // progress but make sure to cancel the previous timeouts so we don't
    // have multiple incs running at the same time.
    if (this._autoIncrement) {
      clearTimeout(this._incTimeout);
      this._incTimeout = setTimeout(() => {
        this.inc();
      }, 250);
    }
  }

  /**
   * Increments the loading bar by a random amount
   * but slows down as it progresses
   */
  private inc(): void {
    if (this._status >= 1) {
      return;
    }

    var rnd = 0;

    // TODO: do this mathmatically instead of through conditions

    var stat = this._status;
    if (stat >= 0 && stat < 0.25) {
      // Start out between 3 - 6% increments
      rnd = (Math.random() * (5 - 3 + 1) + 3) / 100;
    } else if (stat >= 0.25 && stat < 0.65) {
      // increment between 0 - 3%
      rnd = (Math.random() * 3) / 100;
    } else if (stat >= 0.65 && stat < 0.9) {
      // increment between 0 - 2%
      rnd = (Math.random() * 2) / 100;
    } else if (stat >= 0.9 && stat < 0.99) {
      // finally, increment it .5 %
      rnd = 0.005;
    } else {
      // after 99%, don't increment:
      rnd = 0;
    }

    var pct = this._status + rnd;
    this.set(pct);
  }

  public complete(): void {

    this.set(1);

    clearTimeout(this._completeTimeout);
    clearTimeout(this._startTimeout);

    // Attempt to aggregate any start/complete calls within 500ms:
    this._completeTimeout = setTimeout(() => {
      this._started = false;
      this.hide(this._loadingBarContainer);
      this.hide(this._spinner);
    }, 500);
  }

  private show(el: any): void {
    this.setElementStyle(el, "display", "block");
  }

  private hide(el: any): void {
    this.setElementStyle(el, "display", "none");
  }

  private setElementStyle(el: any, styleName: string, styleValue: string): void {
    this._renderer.setElementStyle(el.nativeElement, styleName, styleValue);
  }
}

export class LoadingBarService {
  private static _pendingRequests: number = 0;
  private static _observer: Subscriber<{}>;
  public static pending: Observable<{}> = new Observable(observer => LoadingBarService._observer = observer);

  static requestStarted() {
    let started = (LoadingBarService._pendingRequests == 0);
    LoadingBarService._pendingRequests++;
    LoadingBarService._observer.next({
      started: started,
      pendingRequests: LoadingBarService._pendingRequests
    });
  }

  static requestEnded() {
    let completed = (LoadingBarService._pendingRequests == 1);
    LoadingBarService._pendingRequests--;
    LoadingBarService._observer.next({
      completed: completed,
      pendingRequests: LoadingBarService._pendingRequests
    });
  }
}

@Injectable()
export class LoadingBarBackend extends XHRBackend {
  constructor(_browserXHR: BrowserXhr, _baseResponseOptions: ResponseOptions, _xsrfStrategy: XSRFStrategy) {
    super(_browserXHR, _baseResponseOptions, _xsrfStrategy);
  }

  createConnection(request: Request): XHRConnection {
    let connection = super.createConnection(request);

    connection.response = Observable.of(connection.response)
      .do(LoadingBarService.requestStarted)
      .mergeAll()
      .finally(LoadingBarService.requestEnded);
    return connection;
  }
}

export function LoadingBarBackendFactory(_browserXHR: BrowserXhr, _baseResponseOptions: ResponseOptions, _xsrfStrategy: XSRFStrategy) {
  // subscribe on http activity and update progress
  LoadingBarService.pending.subscribe((progress: any) => {
    setTimeout(() => {
      if (LoadingBar._loadingBarComponentInstance) {
        if (progress.started) LoadingBar._loadingBarComponentInstance.start();
        if (progress.completed) LoadingBar._loadingBarComponentInstance.complete();
      }
    }, 10);
  });

  return new LoadingBarBackend(_browserXHR, _baseResponseOptions, _xsrfStrategy);
}



// WEBPACK FOOTER //
// ./src/app/components/loading-bar/loading-bar.ts